import { useEffect, useState } from "react";
import {
  TextField,
  IconButton,
  Dialog,
  Typography,
  Box,
  Tooltip,
  Container,
  Stack,
  Button,
  BoxProps,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";

import conf from "../../conf";
import SectionHeader from "./SectionHeader";
import { useSmartContent } from "./SmartCell";
import { useProxyKeyEditPartNumber } from "../../hooks/proxy/keys";

type PartNumberWithEditProps = {
  id: string;
  readOnly: boolean;
  partNumber: string;
  alignItems?: BoxProps["alignItems"];
  justifyContent?: BoxProps["justifyContent"];
};

const PartNumberWithEdit = (props: PartNumberWithEditProps) => {
  const {
    id,
    readOnly,
    partNumber,
    alignItems = "center",
    justifyContent = "space-between",
  } = props;

  const edit = useProxyKeyEditPartNumber();

  const [isEditing, setIsEditing] = useState(false);
  const [current, setCurrent] = useState(partNumber);
  const [updated, setUpdated] = useState(current);

  const handleOpen = () => setIsEditing(true);
  const handleClose = () => setIsEditing(false);

  const handleSave = () => {
    setCurrent(updated); // save updated partNumber
    setIsEditing(false);

    edit.mutate({ id, partNumber: updated });
  };

  useEffect(() => {
    setCurrent(partNumber);
    setUpdated(partNumber);
  }, [partNumber]);

  return (
    <>
      <Box
        display="flex"
        alignItems={alignItems}
        justifyContent={justifyContent}
      >
        <Typography>
          <strong>Part No.:</strong>{" "}
          {useSmartContent(current, 8, {
            verticalAlign: "middle",
          })}
        </Typography>

        {!readOnly && (
          <Tooltip title="Edit part no.">
            <IconButton onClick={handleOpen} color="inherit">
              <EditIcon sx={{ fontSize: 14, p: 0 }} />
            </IconButton>
          </Tooltip>
        )}
      </Box>

      {/* Edit Modal */}
      <Dialog fullWidth maxWidth="md" open={isEditing} onClose={handleClose}>
        <Container component="main" sx={conf.STYLE.DIALOG}>
          <SectionHeader
            title="Edit part number"
            icon={<EditIcon />}
            buttons={[
              <Button key="exit-desc" color="inherit" onClick={handleClose}>
                <CloseIcon />
              </Button>,
            ]}
          />

          <TextField
            multiline
            fullWidth
            value={updated}
            variant="outlined"
            onChange={(e) => setUpdated(e.target.value)}
          />

          <Stack
            spacing={2}
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
            sx={{ mt: 2 }}
          >
            <Button variant="contained" onClick={handleSave}>
              Save
            </Button>
          </Stack>
        </Container>
      </Dialog>
    </>
  );
};

export default PartNumberWithEdit;
